import PropTypes from "prop-types";
import GridPalkkiEditor from "./GridPalkkiEditor";
import { useContext } from "react";
import { GridContext } from "src/context/GridContext/GridContext";
import GridPalkkiModal from "../gridPalkkiModal/GridPalkkiModal";
import { PalkkiIcon } from "src/components/icons/PalkkiIcons";
import { isMobile } from "src/components/js/statics1";
import { Typography } from "@mui/material";

export default function GridPalkkiEditorModal() {
  const { isLoaded, gridPalkkiEditorIsOpen, setGridPalkkiEditorIsOpen, setGridPalkki } =
    useContext(GridContext) || {};

  if (!isLoaded) return null;
  const palkki = gridPalkkiEditorIsOpen;

  const handleClose = () => {
    setGridPalkkiEditorIsOpen(false);
    setGridPalkki(null);
  };

  return (
    <GridPalkkiModal
      isDraggable={!isMobile()}
      open={palkki !== false}
      onClose={handleClose}
      rowId={palkki?.palkkiId}
      title={
        <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
          <PalkkiIcon palkki={palkki} />
          <Typography
            color="primary"
            variant="h5"
            align="center"
            className="fixPrint"
            sx={{ display: "flex", gap: 1 }}>
            {palkki?.grid_palkkiType}
          </Typography>
        </span>
      }>
      <GridPalkkiEditor onSave={handleClose} onCancel={handleClose} />
    </GridPalkkiModal>
  );
}

GridPalkkiEditorModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  gridPalkki: PropTypes.object,
  setGridPalkki: PropTypes.func,
};
